import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickNavigationCards = () => {
  const navigationCards = [
  {
    id: 'trails',
    title: 'Thematic Trails',
    titleLocal: 'Tematske Staze',
    description: 'Discover 8 unique trails connecting cultural heritage sites, natural wonders, and local communities across both countries.',
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763457908/Mapa_staze_3.1._eskrj0.png",
    imageAlt: 'Winding mountain trail through lush green forest with wooden signpost and distant mountain peaks',
    icon: 'Map',
    route: '/thematic-trails-overview',
    stats: { trails: 8, countries: 2 },
    color: 'primary'
  },
  {
    id: 'heritage',
    title: 'Heritage Map',
    titleLocal: 'Mapa Nasleđa',
    description: 'Explore interactive map with 77+ cultural and natural heritage sites including monasteries, fortresses, and national parks.',
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763505215/Masiv_Durmitora_kqddrj.jpg",
    imageAlt: 'Ancient stone monastery with red tile roof surrounded by green hills and traditional architecture',
    icon: 'MapPin',
    route: '/heritage-interactive-map',
    stats: { sites: 77, categories: 2 },
    color: 'success'
  },
  {
    id: 'tourism',
    title: 'Tourism Offerings',
    titleLocal: 'Turistička Ponuda',
    description: 'Find authentic local accommodations, traditional restaurants, and unique local products from communities along the trails.',
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763457945/3.7.jpg_mini_c6xvbu.jpg",
    imageAlt: 'Cozy traditional restaurant interior with wooden tables, local crafts on walls, and warm ambient lighting',
    icon: 'Building',
    route: '/tourism-offerings',
    stats: { offerings: 48, categories: 3 },
    color: 'accent'
  }];


  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-foreground mb-4">
            Start Your Journey
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Choose your path to explore the rich heritage and natural beauty of Serbia and Montenegro. 
            Each section offers unique experiences and discoveries.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {navigationCards?.map((card) =>
          <div key={card?.id} className="group">
              <div className="bg-card rounded-2xl shadow-card overflow-hidden card-hover h-full">
                {/* Card Image */}
                <div className="relative h-48 overflow-hidden">
                  <Image
                  src={card?.image}
                  alt={card?.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  
                  {/* Icon Badge */}
                  <div className={`absolute top-4 right-4 w-12 h-12 rounded-full flex items-center justify-center shadow-lg ${
                card?.color === 'primary' ? 'bg-primary' :
                card?.color === 'success' ? 'bg-success' :
                card?.color === 'accent' ? 'bg-accent' : 'bg-primary'}`
                }>
                    <Icon name={card?.icon} size={24} color="white" />
                  </div>
                </div>

                {/* Card Content */}
                <div className="p-6">
                  <div className="mb-4">
                    <h3 className="font-heading font-semibold text-xl text-foreground mb-1">
                      {card?.title}
                    </h3>
                    <p className="text-sm text-muted-foreground font-medium">
                      {card?.titleLocal}
                    </p>
                  </div>

                  <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                    {card?.description}
                  </p>

                  {/* Statistics */}
                  <div className="flex justify-between items-center mb-6 p-3 bg-surface rounded-lg">
                    {Object.entries(card?.stats)?.map(([key, value]) =>
                  <div key={key} className="text-center">
                        <div className={`font-bold text-lg ${
                    card?.color === 'primary' ? 'text-primary' :
                    card?.color === 'success' ? 'text-success' :
                    card?.color === 'accent' ? 'text-accent' : 'text-primary'}`
                    }>
                          {value}+
                        </div>
                        <div className="text-xs text-muted-foreground capitalize">
                          {key}
                        </div>
                      </div>
                  )}
                  </div>

                  {/* CTA Button */}
                  <Link to={card?.route} className="block">
                    <Button
                    variant="default"
                    className={`w-full ${
                    card?.color === 'primary' ? 'bg-primary hover:bg-primary/90' :
                    card?.color === 'success' ? 'bg-success hover:bg-success/90' :
                    card?.color === 'accent' ? 'bg-accent hover:bg-accent/90' : 'bg-primary hover:bg-primary/90'}`
                    }
                    iconName="ArrowRight"
                    iconPosition="right">

                      Explore Now
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default QuickNavigationCards;